// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum SweepOffTime {
    Five = 5,
    Ten = 10,
    Fifteen = 15,
    Twenty = 20,
    TwentyFive = 25,
    Thirty = 30,
    FourtyFive = 45,
    Sixty = 60,
    TenToSixty = 70,
    TwentyToSixty = 80,
    ThirtyToSixty = 90,
}
export default SweepOffTime;
